/**
 * The id of the question the student actually has on screen, sent with every
 * student-input-update. Must match the question the tutor tile renders
 * (TutorLearningSession / TutorHomePageV2): the explanation question while one
 * is showing, otherwise the current quiz or in-lesson question.
 * TutorSingleQuestionPage drops input whose questionId differs from the
 * question it displays.
 */
export function getLiveQuestionId(quizState) {
  if (quizState?.showingExplanation) {
    return quizState.currentExplanationQuestion?._id ?? null;
  }
  return quizState?.currentQuestionId ?? null;
}

/**
 * Lesson-step counterpart of getLiveQuestionId. Returns the populated
 * quizQuestionId._id for the current lesson step, or null on non-question
 * steps / missing state. Must be written into currentQuestionIdRef whenever
 * lesson state broadcasts, otherwise a leftover quiz id makes the tutor
 * discard in-lesson blank-box input.
 */
export function getLessonLiveQuestionId(lessonState) {
  const step = lessonState?.latestLesson?.steps?.[lessonState?.currentLessonStep];
  const q = step?.quizQuestionId;
  if (!q) return null;
  // childTopics populates quizQuestionId as an object; tolerate a bare id string.
  return (typeof q === 'object' ? q._id : q) ?? null;
}
